/* eslint-disable no-useless-escape */
const StringValidations = {
  emailValidationRegex: () => {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  },
}

export default StringValidations;



// WEBPACK FOOTER //
// ./src/utils/StringValidations.js